import blastoise from './benny_art/blastoise1.png';
import bart_simpson from './benny_art/bart_simpson1.png';
import gumball from './benny_art/gumball1.png';
import jack_skellington from './benny_art/jack_skellington1.png';
import pearls_rat from './benny_art/pearls_rat1.png';
import snoopy from './benny_art/snoopy1.png';
import voltorb from './benny_art/voltorb1.png';
import oddish from './benny_art/oddish.png';
import lightbulb_learning from './benny_art/lightbulb_logo.png';
import pixel_cutlass from './benny_art/pixel_cutlass.png';
import random_doodles from './benny_art/random_doodles.png';
import snowman from './benny_art/snowman.png';
import clown_gangster from './benny_art/clown_gangster.png';
import catbug from './benny_art/catbug.png';
import business_cat from './benny_art/business_cat.png';
import green_elephant from './benny_art/green_elephant.png';
import blue_elephant from './benny_art/blue_elephant.png';

const images = {
  blastoise,
  bart_simpson,
  gumball,
  jack_skellington,
  rat: pearls_rat, // Assuming you want to map 'rat' to 'pearls_rat'
  snoopy,
  voltorb,
  oddish,
  lightbulb_learning,
  pixel_cutlass,
  random_doodles,
  snowman,
  clown_gangster,
  catbug,
  business_cat,
  green_elephant,
  blue_elephant,
};

export default images;